import { Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'ecu-card',
  templateUrl: './card.component.html',
})
export class CardComponent {
  @Input() public bgColor: ThemePalette;

  get class(): string {
    switch(this.bgColor) {
      case 'primary':
        return 'bg-primary text-white';
      case 'accent':
        return 'bg-warning text-white';
      case 'warn':
        return 'bg-danger text-white';
      default:
        return undefined;
    }
  }
}
